import {
  Bar,
  BarChart,
  CartesianGrid,
  Cell,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts';

interface SimpleBarChartProps {
  data: { label: string; value: number; color?: string }[];
  height?: number;
  formatValue?: (value: number) => string;
}

export function SimpleBarChart({
  data,
  height = 300,
  formatValue = v => v.toLocaleString('fr-FR'),
}: SimpleBarChartProps) {
  if (data.length === 0) return null;

  const chartData = data.map(item => ({
    name: item.label,
    value: item.value,
    color: item.color || '#3b82f6',
  }));

  // Use the first item's color if all have the same color, otherwise use default
  const barColor =
    data.length > 0 && data.every(d => d.color === data[0].color)
      ? data[0].color || '#3b82f6'
      : '#3b82f6';

  return (
    <ResponsiveContainer width="100%" height={height}>
      <BarChart
        data={chartData}
        margin={{ top: 20, right: 30, left: 20, bottom: 5 }}
      >
        <CartesianGrid strokeDasharray="3 3" stroke="#e5e7eb" />
        <XAxis
          dataKey="name"
          stroke="#6b7280"
          fontSize={12}
          tickLine={false}
          axisLine={false}
        />
        <YAxis
          stroke="#6b7280"
          fontSize={12}
          tickLine={false}
          axisLine={false}
          tickFormatter={value => formatValue(value)}
        />
        <Tooltip
          contentStyle={{
            backgroundColor: 'white',
            border: '1px solid #e5e7eb',
            borderRadius: '8px',
            padding: '8px 12px',
          }}
          formatter={value => formatValue(Number(value))}
          labelStyle={{
            color: '#374151',
            fontWeight: 600,
            marginBottom: '4px',
          }}
        />
        <Bar
          dataKey="value"
          fill={barColor}
          radius={[8, 8, 0, 0]}
          className="transition-opacity hover:opacity-80"
        >
          {chartData.map((entry, index) => (
            <Cell key={`cell-${index}`} fill={entry.color} />
          ))}
        </Bar>
      </BarChart>
    </ResponsiveContainer>
  );
}
